import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useModuleIds } from 'portal/lib/hooks'
import { snippetsLoad } from 'portal/store/records/snippets/actions'

export const useSnippetsLoader = () => {
  const dispatch = useDispatch()
  const { accountId, projectId, moduleName, recordId } = useModuleIds()

  const reload = useCallback(() => {
    if (!accountId || !projectId || !moduleName || !recordId) {
      return
    }
    dispatch(snippetsLoad(accountId, projectId, moduleName, recordId))
  }, [dispatch, accountId, projectId, moduleName, recordId])

  useEffect(() => {
    reload()
  }, [reload])

  const { loading, error, data } = useSelector((state: any) => {
    return state.records.snippets
  })

  return {
    loading,
    error,
    data,
    reload
  }
}
